import React, { useState } from "react";
import HelloText from "../components/HelloText";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const HealthAddTest = () => {
  const [link, setLink] = useState();
  const [name, setName] = useState();
  const [language, setLanguage] = useState();
  const [Image, setImage] = useState();
  const [text, setText] = useState();
  const [tag, setTag] = useState();
  const [description, setDescription] = useState();
  const [title, setTitle] = useState();
  const [metaTitle, setmetaTitle] = useState();
  const [metDescription, setmetDescription] = useState();
  const [schema, setschema] = useState();
  const avatarHandle = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.addEventListener("load", function () {
      setImage(this.result);
    });
    reader.readAsDataURL(file);
  };
  const API_URL = "https://api.metincevener.com/img";
  const UPLOAD_ENDPOINT = "ckup/ckup";
  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("uploadImg", file);
            // let headers = new Headers();
            // headers.append("Origin", "http://localhost:3000");
            fetch(`${API_URL}/${UPLOAD_ENDPOINT}`, {
              method: "post",
              body: body,
              // mode: "no-cors"
            })
              .then((res) => res.json())
              .then((res) => {
                resolve({
                  default: `${API_URL}/${res.filename}`,
                });
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
      },
    };
  }
  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }
  return (
    <>
      <HelloText />
      <Box
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "healthaddtest.php"}
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
        autoComplete="off"
        encType="multipart/form-data"
      >
        <TextField
          id="outlined-basics"
          label="Başlık"
          variant={"outlined"}
          fullWidth
          name="health_title"
          onChange={(e) => setTitle(e.target.value)}
          value={title}
        />

        <TextField
          id="outlined-basics"
          label="description"
          variant={"outlined"}
          fullWidth
          multiline
          minRows={3}
          maxRows={8}
          name="health_description"
          onChange={(e) => setDescription(e.target.value)}
          value={description}
        />
        <div className="editor">
          <CKEditor
            editor={ClassicEditor}
            config={{
              extraPlugins: [uploadPlugin],
              mediaEmbed: {
                previewsInData: true,
              },
            }}
            data=""
            onReady={(editor) => {
              // You can store the "editor" and use when it is needed.
              //console.log("Editor is ready to use!", editor);
            }}
            onChange={(event, editor) => {
              const data = editor.getData();
              //console.log({ event, editor, data });
              setText(data);
            }}
            onBlur={(event, editor) => {
              //console.log("Blur.", editor);
            }}
            onFocus={(event, editor) => {
              //console.log("Focus.", editor);
            }}
          />
        </div>

        <input type="text" name="health_text" value={text} />
        <label for="lang">Dil:</label>
        <select
          name="health_lang"
          id="lang"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="tr-TR">tr</option>
          <option value="en-gb">en</option>
        </select>
        {Image ? (
          <img
            id="blah"
            src={Image}
            alt="your image"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        ) : (
          ""
        )}
        <Button variant="contained" component="label">
          Resim yükle
          <input
            hidden
            accept="image/*"
            multiple
            type="file"
            name="health_image"
            onChange={avatarHandle}
          />
        </Button>
        <p>Meta Alanı</p>
        <TextField
          id="outlined-basics"
          label="tags"
          variant={"outlined"}
          fullWidth
          name="health_keywords"
          onChange={(e) => setTag(e.target.value)}
          value={tag}
        />
        <TextField
          id="outlined-basics"
          label="Meta Title"
          variant={"outlined"}
          fullWidth
          name="meta_title"
          onChange={(e) => setmetaTitle(e.target.value)}
          value={metaTitle}
          multiline
          minRows={3}
          maxRows={8}
        />
        <TextField
          id="outlined-basics"
          label="Meta Description"
          variant={"outlined"}
          fullWidth
          name="meta_description"
          onChange={(e) => setmetDescription(e.target.value)}
          value={metDescription}
          multiline
          minRows={3}
          maxRows={8}
        />
        <TextField
          id="outlined-basics"
          label="Schema"
          variant={"outlined"}
          fullWidth
          name="meta_schema"
          onChange={(e) => setschema(e.target.value)}
          value={schema}
          multiline
          minRows={3}
          maxRows={18}
        />

        <Button variant="outlined" type="submit">
          Ekle
        </Button>
      </Box>
    </>
  );
};

export default HealthAddTest;
